export function isNullOrUndefined(value: any) {
    return value === null || value === undefined;
}
export function isNotNullOrUndefined(value){
    if(value!== null && value !== undefined){
      return true;
    }
    return false;
  }